import React from 'react';
import { Message } from 'semantic-ui-react';

/**
 * Placeholder for the Variations List component
 * This will be replaced with the new variationWorksheet implementation
 * 
 * @returns {JSX.Element} VariationsList component
 */
const VariationsList = () => {
  return (
    <Message info>
      <Message.Header>Coming Soon</Message.Header>
      <p>
        The Variations List feature is currently being reimplemented with an improved architecture.
        This feature will be available in a future update.
      </p>
    </Message>
  );
};

export default VariationsList;
